import { t } from "@lingui/core/macro";

import { DialogDescription, DialogHeader, DialogTitle } from "@/shared/components/ui/dialog";

type FeedbackDialogResponseProps = {
  source: "feedbackLink" | "errorBoundary";
  isSuccess: boolean;
};

export default function FeedbackDialogResponse({ source, isSuccess }: FeedbackDialogResponseProps) {
  return (
    <DialogHeader>
      <DialogTitle>
        {!isSuccess ? t`Error` : source === "errorBoundary" ? t`Issue Reported` : t`Feedback Submitted`}
      </DialogTitle>
      <DialogDescription>
        {!isSuccess
          ? t`There was an error submitting your feedback. Please try again later.`
          : source === "errorBoundary"
            ? t`Thank you for reporting this issue. We'll investigate and fix it as soon as possible.`
            : t`Thank you for your feedback. We appreciate you taking the time to help us improve.`}
      </DialogDescription>
    </DialogHeader>
  );
}
